const UploadHistoryActions = {
    Get: "UPLOADHISTORY.GET",
    Got: "UPLOADHISTORY.GOT",
    GetErrored: "UPLOADHISTORY.GETERRORED",
    GetAll: "UPLOADHISTORY.GETALL",
    GotAll: "UPLOADHISTORY.GOTALL",
    GetAllErrored: "UPLOADHISTORY.GETALLERRORED",
};

module.exports = UploadHistoryActions;


// WEBPACK FOOTER //
// ./src/actions/UploadHistoryActions.js